import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import "./style.css";
import { BsArrowsAngleContract, BsArrowsAngleExpand } from "react-icons/bs";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LineChartLoadingComp = ({ isExpand, setIsExpand }) => {
    return (
        <div
            className="bg-white py-4 px-0 rounded-5"
            style={{ boxShadow: " 2px 5px 10px gray" }}
        >
            {isExpand ? (
                <div className="text-end pe-4">
                    <BsArrowsAngleContract
                        color="gray"
                        onClick={() => setIsExpand(false)}
                    />
                </div>
            ) : (
                <div className="text-end pe-4">
                    <BsArrowsAngleExpand color="gray" onClick={() => setIsExpand(true)} />
                </div>
            )}

            <Tab.Container id="dateRange" defaultActiveKey="today">
                <ul className="nav nav-tabs mb-3 mt-2">
                    <li className="nav-item">
                        <button className={`nav-link active`} >
                            Month to Date
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link `}>
                            Financial Year
                        </button>
                    </li>
                </ul>
                <Tab.Content>
                    <Tab.Pane eventKey="today">
                        <div className="py-3 mt-3 px-2">
                            <Skeleton count={10} />
                        </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="daily">
                        <div className="py-3 mt-3 px-2">
                            <Skeleton count={10} />
                        </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="weekly">
                        <div className="py-3 mt-3 px-2">
                            <Skeleton count={10} />
                        </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="monthly">
                        <div className="py-3 mt-3 px-2">
                            <Skeleton count={10} />
                        </div>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};

export default LineChartLoadingComp;
